import AppRouter from './router/AppRouter.tsx';
import SmoothScroll from '../shared/ui/components/animations/SmoothScroll.tsx';
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { RouteErrorBoundary } from '../shared/ui/components/errors/RouteErrorBoundary.tsx';
import ScrollToTop from '../shared/ui/components/navigation/ScrollToTop.tsx';

function NavigationDebugLogger() {
  const location = useLocation();
  const navCountRef = useRef(0);

  useEffect(() => {
    if (!import.meta.env.PROD) return;
    navCountRef.current += 1;
    console.debug('[nav]', navCountRef.current, location.pathname + location.search + location.hash);
  }, [location]);

  return null;
}

function App() {
  return (
    <>
      <ScrollToTop />
      <SmoothScroll />
      <NavigationDebugLogger />
      <RouteErrorBoundary>
        <AppRouter />
      </RouteErrorBoundary>
    </>
  );
}

export default App;
